import {
  FilledLinkToDocumentField,
  FilledLinkToMediaField,
  FilledLinkToWebField,
  ImageField,
  LinkField,
  LinkType,
} from '@prismicio/types'
import {
  ScrollOverMediaDocumentDataBodyImagePanoramaStepSlice,
  ScrollOverMediaDocumentDataBodyImageParallaxStepSlice,
  ScrollOverMediaDocumentDataBodyImageStepSlice,
  ScrollOverMediaDocumentDataBodyLottieStepSlice,
  ScrollOverMediaDocumentDataBodyVideoStepSlice,
} from '../../types.generated'
import {
  ContentRelationshipField,
  FilledContentRelationshipField,
} from '@prismicio/client'

// Simple union type since prismic generated types does not export this
export type ScrollOverMediaSlices =
  | ScrollOverMediaDocumentDataBodyImageStepSlice
  | ScrollOverMediaDocumentDataBodyImagePanoramaStepSlice
  | ScrollOverMediaDocumentDataBodyImageParallaxStepSlice
  | ScrollOverMediaDocumentDataBodyVideoStepSlice
  | ScrollOverMediaDocumentDataBodyLottieStepSlice

export const getLinkFieldUrl: (link?: LinkField) => string = (link) => {
  const isFilledLinkWithUrl = (
    link: LinkField
  ): link is
    | FilledLinkToWebField
    | FilledLinkToDocumentField
    | FilledLinkToMediaField => {
    return link.link_type !== LinkType.Any
  }

  if (link && isFilledLinkWithUrl(link)) {
    return link.url ?? ''
  }

  return ''
}

export const getImageUrl: (
  link: ImageField<'portrait'>,
  usePortrait: boolean
) => string = (link, usePortrait) => {
  if (usePortrait && link.portrait?.url) {
    return link.portrait.url ?? ''
  }

  return link.url ?? ''
}

export const isFilledContentRelationshipField = (
  link: ContentRelationshipField
): link is FilledContentRelationshipField => {

  const isDocumentLink = (
    link: LinkField
  ): link is FilledLinkToDocumentField => {
    return link.link_type === LinkType.Document
  }

  return link && isDocumentLink(link) && !!link.id
}
